import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_URL}/auth`;

// Configurar axios para enviar cookies automáticamente
axios.defaults.withCredentials = true;

export const login = async (username, password) => {
  try {
    const response = await axios.post(`${API_URL}/login`, { username, password });
    return response.data;
  } catch (error) {
    // Intentar obtener el mensaje de error del backend
    if (error.response?.data?.message) {
      throw error.response.data.message;
    }

    // Mensajes específicos según el código de estado
    if (error.response?.status === 401) {
      throw "Usuario o contraseña incorrectos";
    } else if (error.response?.status === 403) {
      throw "Usuario inactivo. Contacte al administrador";
    } else if (error.code === 'ECONNREFUSED' || error.code === 'ERR_NETWORK') {
      throw "No se puede conectar con el servidor";
    } else if (!error.response) {
      throw "Error de red. Verifique su conexión";
    }

    throw "Error al iniciar sesión";
  }
};

export const refreshToken = async () => {
  try {
    const response = await axios.post(`${API_URL}/refresh`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Sesión expirada";
  }
};

export const logout = async () => {
  try {
    await axios.post(`${API_URL}/logout`);
  } catch (error) {
    // Ignorar errores en logout
    console.warn('Error durante logout:', error);
  }
};

export const changePassword = async (currentPassword, newPassword, token) => {
  try {
    const response = await axios.post(
      `${API_URL}/change-password`,
      { currentPassword, newPassword },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Error al cambiar la contraseña";
  }
};

export const validateToken = async (token) => {
  try {
    // Intentar refrescar el token para validar la sesión
    // Si el refresh token es válido, la sesión es válida
    const response = await refreshToken();

    // Si llegamos aquí, el refresh fue exitoso
    // Actualizar el token en localStorage con el nuevo token
    if (response.accessToken) {
      localStorage.setItem('token', response.accessToken);
    }

    return true;
  } catch (error) {
    // Si el refresh falla, la sesión ha expirado completamente
    return false;
  }
};
